import { render, staticRenderFns } from "./categoryChart.vue?vue&type=template&id=5dad9d54&scoped=true"
import script from "./categoryChart.vue?vue&type=script&lang=js"
export * from "./categoryChart.vue?vue&type=script&lang=js"
import style0 from "./categoryChart.vue?vue&type=style&index=0&id=5dad9d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dad9d54",
  null
  
)

export default component.exports